import {Component, OnInit} from '@angular/core';
import {MyModalService} from '../modal.service';
import {OdmoriService} from '../../odmori.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';

@Component({
  selector: 'confirm-modal',
  templateUrl: './confirm.modal.html',
  styleUrls: ['./confirm.modal.css']
})

export class ConfirmModal implements OnInit  {

  constructor(private modalService: MyModalService, private odmoriService: OdmoriService, private toastr: ToastrService, private router: Router) {} 

  pending: boolean = false;

  ngOnInit() {}

  confirm() {
    let request = this.modalService.getRequest();
    const requestCopy =  JSON.parse(JSON.stringify(request));

    this.pending = true;

    this.odmoriService.changeStatusOfRequest(request, 'employee_reject', requestCopy['status']).subscribe(result => {
      this.pending = false;

      if (result.type === 'success') {
        this.toastr.success('Uspješno ste promijenili status zahtjeva.');
        this.router.navigate(['/odmori']);
        
        this.cancel();

        return;
      };

      this.toastr.error('Došlo je do greške. Molimo vas da se obratite korisničkoj podršci.');
    });

  };

  cancel() {
    this.modalService.closeModal();
  };
}